import React from "react";
import * as R from "ramda";
import { Tag, Tooltip, Icon, message } from "antd";
import copy from "copy-to-clipboard";

import styled from "styled-components/macro";

const TagsWrapper = styled.div`
  /* Reset line-height from antd */
  line-height: initial;
  margin-top: 12px;
  margin-bottom: 8px;

  .ant-tag {
    margin: 3px;
    cursor: pointer;
  }

  .title {
    margin-bottom: 4px;
  }
`;

export default function Tags({ t, isDisabled }) {
  return (
    <TagsWrapper>
      <h4 className="title">
        <span style={{ marginRight: 8 }}>
          {t("opportunity:process.stepDetails.availableTags")}
        </span>
        <Tooltip
          title={t(
            "opportunity:process.stepDetails.availableTagsDescriptionOffer"
          )}
        >
          <Icon type="question-circle" />
        </Tooltip>
      </h4>
      <div>
        {R.map(tag => (
          <Tag
            onClick={() => {
              if (isDisabled) return;
              copy(tag);
              message.success(
                "Tag copiado al portapapeles. Insertalo en el editor."
              );
            }}
            key={tag}
          >
            {tag}
          </Tag>
        ))([
          "[Ubicación]",
          "[Fecha actual]",
          "[Nombre del Candidato]",
          "[Nombre de la Compañía]",
          "[Título de la Oportunidad]",
          "[Fecha de ingreso]",
          "[Modalidad]",
          "[Moneda]",
          "[Salario]",
          "[Nombre del Reclutador]",
          "[Dirección del Candidato]",
          "[Tipo y Nro. de Documento del Candidato]"
        ])}
      </div>
    </TagsWrapper>
  );
}
